import {
	getPageEventsReport,
	getQuizTestReport,
} from '@/API/repositories/reports';
import { useRequestsContext } from '@/common/hooks/requestHook';
import { useMessageQueueContext } from '@/common/hooks/useMessageQueue';
import { useState } from 'react';

const usePageEventsReport = () => {
	const { addMessage } = useMessageQueueContext();
	const { makeRequest, hasUnfilledRequest } = useRequestsContext();
	const [data, setData] = useState();

	const isLoading = hasUnfilledRequest(getPageEventsReport);

	const fetchPageEventsReportData = async (
		browserPersonDayFrom,
		browserPersonDayTo,
		domain,
		sourceEvent,
		targetEvent,
		test,
		isOnlinePayment,
	) => {
		const payload = {
			browserPersonDayFrom,
			browserPersonDayTo,
			domain,
			sourceEvent,
			targetEvent,
			test,
		};

		if (isOnlinePayment) {
			payload.isOnlinePayment = true;
		}

		const response = await makeRequest(getPageEventsReport.bind(null, payload));

		if (!response.data) {
			return addMessage('Something went wrong', 'error');
		}
		setData(response.data);
	};

	return {
		fetchPageEventsReportData,
		isLoading,
		data,
	};
};

export default usePageEventsReport;
